module.exports = __webpack_public_path__ + "img/mm.6601070a.svg";